import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "measuringPoint" }
const _hoisted_2 = { class: "advice flex" }
const _hoisted_3 = { class: "chartWrapper" }
const _hoisted_4 = { class: "col1_2" }
const _hoisted_5 = { class: "particleContent" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "name" }, "PM 10", -1)
const _hoisted_8 = { class: "quantity" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("sup", null, "3", -1)
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "name" }, "PM 2,5", -1)
const _hoisted_12 = { class: "quantity" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("sup", null, "3", -1)
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "name" }, [
  /*#__PURE__*/_createTextVNode("SO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2")
], -1)
const _hoisted_16 = { class: "quantity" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("sup", null, "3", -1)
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "name" }, [
  /*#__PURE__*/_createTextVNode("NO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2")
], -1)
const _hoisted_20 = { class: "quantity" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("sup", null, "3", -1)
const _hoisted_22 = { class: "flex" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "name" }, [
  /*#__PURE__*/_createTextVNode("O"),
  /*#__PURE__*/_createElementVNode("sub", null, "3")
], -1)
const _hoisted_24 = { class: "quantity" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("sup", null, "3", -1)
const _hoisted_26 = { class: "lastSevenDays" }
const _hoisted_27 = { class: "flex header" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, " ", -1)
const _hoisted_29 = { class: "time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdvancedGaugeChart = _resolveComponent("AdvancedGaugeChart")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_SidebarWrapper = _resolveComponent("SidebarWrapper")!

  return (_openBlock(), _createBlock(_component_SidebarWrapper, {
    title: _ctx.$t('air_quality.title'),
    sidebarComponent: _ctx.sidebarComponent,
    mapComponent: _ctx.mapComponent,
    sidebarLeft: true
  }, {
    default: _withCtx(() => [
      (_ctx.sensor !== null)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("air_quality.measuring_point")), 1),
              _createElementVNode("h2", null, _toDisplayString(_ctx.sensor.name), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.sensor.hardware_id), 1)
            ]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_AdvancedGaugeChart, {
                  percentage: parseInt(_ctx.sensor.measurements?.index) || 0,
                  min: 0,
                  max: 200,
                  bands: [
              {
                from: 0,
                to: 50,
                color: '#00a651',
                thickness: '45%',
              },
              {
                from: 50,
                to: 75,
                color: '#ffb000',
                thickness: '45%',
              },
              {
                from: 75,
                to: 100,
                color: '#fd8935',
                thickness: '45%',
              },
              {
                from: 100,
                to: 200,
                color: '#f05455',
                thickness: '45%',
              },
            ]
                }, null, 8, ["percentage"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t("air_quality.advice")), 1),
                _createElementVNode("p", null, _toDisplayString(parseInt(_ctx.sensor.measurements?.index)) + " " + _toDisplayString(_ctx.$t("air_quality.quality_is")) + " " + _toDisplayString(_ctx.getSensorIndexText(_ctx.sensor.measurements?.index)) + ". ", 1)
              ])
            ]),
            _createVNode(_component_Accordion, {
              multiple: true,
              class: "particleContentInfo",
              activeIndex: [0, 1]
            }, {
              default: _withCtx(() => [
                (_ctx.sensor.measurements !== null)
                  ? (_openBlock(), _createBlock(_component_AccordionTab, { key: 0 }, {
                      header: _withCtx(() => [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("air_quality.particles")), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", _hoisted_6, [
                              _hoisted_7,
                              _createElementVNode("div", {
                                class: _normalizeClass(["progressBar", _ctx.getValueColorClass('pm10', _ctx.sensor.measurements.PM10)])
                              }, [
                                _createVNode(_component_ProgressBar, {
                                  value: (_ctx.sensor.measurements.PM10 / _ctx.aqRanges.pm10[3]) * 100
                                }, null, 8, ["value"])
                              ], 2),
                              _createElementVNode("span", _hoisted_8, [
                                _createTextVNode(_toDisplayString(parseFloat(_ctx.sensor.measurements.PM10).toFixed(2)) + " μg/m", 1),
                                _hoisted_9
                              ])
                            ]),
                            _createElementVNode("li", _hoisted_10, [
                              _hoisted_11,
                              _createElementVNode("div", {
                                class: _normalizeClass(["progressBar", _ctx.getValueColorClass('pm25', _ctx.sensor.measurements.PM2_5)])
                              }, [
                                _createVNode(_component_ProgressBar, {
                                  value: 
                      (_ctx.sensor.measurements.PM2_5 / _ctx.aqRanges.pm25[3]) * 100
                    
                                }, null, 8, ["value"])
                              ], 2),
                              _createElementVNode("span", _hoisted_12, [
                                _createTextVNode(_toDisplayString(parseFloat(_ctx.sensor.measurements.PM2_5).toFixed(2)) + " μg/m", 1),
                                _hoisted_13
                              ])
                            ]),
                            _createElementVNode("li", _hoisted_14, [
                              _hoisted_15,
                              _createElementVNode("div", {
                                class: _normalizeClass(["progressBar", _ctx.getValueColorClass('so2', _ctx.sensor.measurements.SO2)])
                              }, [
                                _createVNode(_component_ProgressBar, {
                                  value: 
                      (_ctx.sensor.measurements.SO2 / 0.000355 / _ctx.aqRanges.so2[3]) *
                      100
                    
                                }, null, 8, ["value"])
                              ], 2),
                              _createElementVNode("span", _hoisted_16, [
                                _createTextVNode(_toDisplayString(parseFloat(_ctx.sensor.measurements.SO2 / 0.000355).toFixed(2)) + " μg/m", 1),
                                _hoisted_17
                              ])
                            ]),
                            _createElementVNode("li", _hoisted_18, [
                              _hoisted_19,
                              _createElementVNode("div", {
                                class: _normalizeClass(["progressBar", _ctx.getValueColorClass('no2', _ctx.sensor.measurements.NO2)])
                              }, [
                                _createVNode(_component_ProgressBar, {
                                  value: 
                      (_ctx.sensor.measurements.NO2 / 0.000494 / _ctx.aqRanges.no2[3]) *
                      100
                    
                                }, null, 8, ["value"])
                              ], 2),
                              _createElementVNode("span", _hoisted_20, [
                                _createTextVNode(_toDisplayString(parseFloat(_ctx.sensor.measurements.NO2 / 0.000494).toFixed(2)) + " μg/m", 1),
                                _hoisted_21
                              ])
                            ]),
                            _createElementVNode("li", _hoisted_22, [
                              _hoisted_23,
                              _createElementVNode("div", {
                                class: _normalizeClass(["progressBar", _ctx.getValueColorClass('o3', _ctx.sensor.measurements.O3)])
                              }, [
                                _createVNode(_component_ProgressBar, {
                                  value: 
                      (_ctx.sensor.measurements.O3 / 0.000473 / _ctx.aqRanges.o3[3]) * 100
                    
                                }, null, 8, ["value"])
                              ], 2),
                              _createElementVNode("span", _hoisted_24, [
                                _createTextVNode(_toDisplayString(parseFloat(_ctx.sensor.measurements.O3 / 0.000473).toFixed(2)) + " μg/m", 1),
                                _hoisted_25
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_AccordionTab, null, _createSlots({
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _hoisted_28,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableDays, (day, index) => {
                          return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(day), 1))
                        }), 128))
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sensor.history, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "flex body",
                          key: index
                        }, [
                          _createElementVNode("span", _hoisted_29, _toDisplayString(item[0]), 1),
                          _createElementVNode("span", {
                            class: _normalizeClass(_ctx.getValueColorClass('index', item[1]))
                          }, [
                            _createElementVNode("small", null, _toDisplayString(item[1]), 1)
                          ], 2),
                          _createElementVNode("span", {
                            class: _normalizeClass(_ctx.getValueColorClass('index', item[2]))
                          }, [
                            _createElementVNode("small", null, _toDisplayString(item[2]), 1)
                          ], 2),
                          _createElementVNode("span", {
                            class: _normalizeClass(_ctx.getValueColorClass('index', item[3]))
                          }, [
                            _createElementVNode("small", null, _toDisplayString(item[3]), 1)
                          ], 2),
                          _createElementVNode("span", {
                            class: _normalizeClass(_ctx.getValueColorClass('index', item[4]))
                          }, [
                            _createElementVNode("small", null, _toDisplayString(item[4]), 1)
                          ], 2),
                          _createElementVNode("span", {
                            class: _normalizeClass(_ctx.getValueColorClass('index', item[5]))
                          }, [
                            _createElementVNode("small", null, _toDisplayString(item[5]), 1)
                          ], 2),
                          _createElementVNode("span", {
                            class: _normalizeClass(_ctx.getValueColorClass('index', item[6]))
                          }, [
                            _createElementVNode("small", null, _toDisplayString(item[6]), 1)
                          ], 2),
                          _createElementVNode("span", {
                            class: _normalizeClass(_ctx.getValueColorClass('index', item[7]))
                          }, [
                            _createElementVNode("small", null, _toDisplayString(item[7]), 1)
                          ], 2)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 2
                }, [
                  (_ctx.sensor.history !== null)
                    ? {
                        name: "header",
                        fn: _withCtx(() => [
                          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("air_quality.last_7")), 1)
                        ])
                      }
                    : undefined
                ]), 1024)
              ]),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "sidebarComponent", "mapComponent"]))
}